export const REPORTS = {
  write_off_letter: {
    id: "write_off_letter",
    label: "Write Off Letter",
  },
  manufacturer_debit_list: {
    id: "manufacturer_debit_list",
    label: "Manufacturer Debit List",
  },
  consolidated_reports_partnered: {
    id: "consolidated_reports_partnered",
    label: "Consolidated Reports",
  },
  consolidated_reports_nonpartnered: {
    id: "consolidated_reports_nonpartnered",
    label: "Consolidated Reports",
  },
  consolidated_reports_rcp: {
    id: "consolidated_reports_rcp",
    label: "Consolidated Reports",
  },
   order_summary_nonpartnered: {
    id: "order_summary_nonpartnered",
    label: "Order Summary",
  },
  order_summary_partnered: {
    id: "order_summary_partnered",
    label: "Order Summary",
  },
  order_summary_rcp: {
    id: "order_summary_rcp",
    label: "Order Summary",
  },
   returnable_product_detail_partnered: {
    id: "returnable_product_detail_partnered",
    label: "Returnable Product Detail",
  },
   returnable_product_detail_nonpartnered: {
    id: "returnable_product_detail_nonpartnered",
    label: "Returnable Product Detail",
  },
    returnable_product_detail_rcp: {
    id: "returnable_product_detail_rcp",
    label: "Returnable Product Detail",
  },
    non_returnable_product_detail_partnered: {
    id: "non_returnable_product_detail_partnered",
    label: "Non-Returnable Product Detail",
  },
    non_returnable_product_detail_nonpartnered: {
    id: "non_returnable_product_detail_nonpartnered",
    label: "Non-Returnable Product Detail",
  },
    non_returnable_product_detail_rcp: {
    id: "non_returnable_product_detail_rcp",
    label: "Non-Returnable Product Detail",
  },
   schedule_ii_product_detail_partnered: {
    id: "schedule_ii_product_detail_partnered",
    label: "Schedule II Product Detail",
  },
    schedule_ii_product_detail_nonpartnered: {
    id: "schedule_ii_product_detail_nonpartnered",
    label: "Schedule II Product Detail",
  },
     schedule_ii_product_detail_rcp: {
    id: "schedule_ii_product_detail_rcp",
    label: "Schedule II Product Detail",
  },
  schedule_iii_v_product_detail_partnered: {
    id: "schedule_iii_v_product_detail_partnered",
    label: "Schedule III-V Product Detail",
  },
    schedule_iii_v_product_detail_nonpartnered: {
    id: "schedule_iii_v_product_detail_nonpartnered",
    label: "Schedule III-V Product Detail",
  },
     schedule_iii_v_product_detail_rcp: {
    id: "schedule_iii_v_product_detail_rcp",
    label: "Schedule III-V Product Detail",
  },

   legend_and_otc_product_detail_partnered: {
    id: "legend_and_otc_product_detail_partnered",
    label: "Legend and OTC Product Detail",
  },
   legend_and_otc_product_detail_nonpartnered: {
    id: "legend_and_otc_product_detail_nonpartnered",
    label: "Legend and OTC Product Detail",
  },
     legend_and_otc_product_detail_rcp: {
    id: "legend_and_otc_product_detail_rcp",
    label: "Legend and OTC Product Detail",
  },
} as const;

export type ReportId = keyof typeof REPORTS;
export type ReportDefinition = (typeof REPORTS)[ReportId];
